//Sass 컴파일
import '../../sass/sub/_favorite.scss';

export function keywordPopActive(el) {
	$(el).find('ul li a').click(function() {
		$(el).find('ul li a').removeClass('active');
		$(this).addClass('active');
	});
}

window.keywordPopActive = keywordPopActive;



// WEBPACK FOOTER //
// ./js/sub/favorite.js